export const PURPLE = 'rgb(148, 26, 189)';
export const PINK = 'rgb(246, 31, 126)';
export const LIGHT_PINK = 'rgba(246, 31, 126, 0.2)';
export const ORANGE = 'rgb(254, 164, 120)';
export const LIGHT_ORANGE = 'rgba(254, 164, 120, 0.51)';
export const LIGHTER_ORANGE = 'rgba(254, 164, 120, 0.2)';
export const DARK_BLUE = 'rgb(0, 35, 78)';
export const FADED_DARK_BLUE = 'rgb(0, 35, 78, 0.4)';
export const GREY = 'rgb(102, 102, 102)';
